import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const location = useLocation();

  const handleProjectsClick = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.history.replaceState(null, '', '/#projects');
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link to="/" className="navbar-home-icon" aria-label="Home (Mikhail Ignatyev)">
          <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" style={{display: 'block'}}>
            <circle cx="22" cy="22" r="20" fill="url(#grad)"/>
            <defs>
              <linearGradient id="grad" x1="0" y1="0" x2="44" y2="44" gradientUnits="userSpaceOnUse">
                <stop stopColor="#00d4ff"/>
                <stop offset="1" stopColor="#08f7fe"/>
              </linearGradient>
            </defs>
            <text x="50%" y="60%" textAnchor="middle" dominantBaseline="middle" fontFamily="'Calligraffiti'" fontSize="28" fontWeight="normal" fill="#181a20">MI</text>
          </svg>
        </Link>
      </div>
      <div className="navbar-right">
        <Link to="/">Home</Link>
        <Link to="/#projects" onClick={handleProjectsClick}>Projects</Link>
        <Link to="/resume">Resume</Link>
        <Link to="/contact">Contact</Link>
      </div>
    </nav>
  );
}

export default Navbar; 